import { AppType } from "@swivl-mono/types";
import { LayoutWithSidebar } from "@swivl-mono/ui";
import _ from "lodash";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

import { SidebarLink } from "../../../Components/SidebarLink/SidebarLink";
import AppsModel from "../../../Models/Apps/Apps.Model";
import { AppsDetailsView } from "./AppsDetailsView";
import "./AppsView.scss";

export default function AppSettingsView() {
  const params = useParams<{ appType?: string; appId?: string }>();
  useEffect(() => {
    AppsModel.load(true);
  }, []);

  return (
    <LayoutWithSidebar
      className="AppsView"
      sidebar={
        <div className="flex flex-col mt-5">
          <SidebarLink to={`/settings/apps/${AppType.GOOGLE}`} height={38}>
            Google
          </SidebarLink>
          {/* <SidebarLink to={`/settings/apps/${AppType.HUBSPOT}`}   height={38}>Hubspot</SidebarLink> */}
          <SidebarLink to={`/settings/apps/${AppType.MANDRILL}`} height={38}>
            Mandrill
          </SidebarLink>
          {/* <SidebarLink to={`/settings/apps/${AppType.SLACK}`} height={38}>
            Slack
          </SidebarLink> */}
          <SidebarLink to={`/settings/apps/${AppType.TWILIO}`} height={38}>
            Twilio
          </SidebarLink>
          {/* <SidebarLink to={`/settings/apps/${AppType.FACEBOOK_MESSENGER}`} height={38}>
            Facebook Messenger
          </SidebarLink> */}
          {/* TODO: Uncomment this after implementing embedded signin */}
          {/* <SidebarLink to={`/settings/apps/${AppType.WHATSAPP}`} height={38}>
            WhatsApp
          </SidebarLink> */}
        </div>
      }
      content={params.appType ? <AppsDetailsView type={params.appType as AppType} appId={params.appId} /> : <></>}
    />
  );
}
